/*
	base url, e.g. "/index.cfm"
*/

module.exports = '/index.cfm';
